/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2023, 2025
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([], () => {

	return {
		EDGE_SLOT_IDS: {
			ROW: 'row_level1',
			COLUMN: 'column_level1',
			VALUES:'values',
			HEAT: 'heat'
		},

		AREA_TYPE: {
			ROW: 'cell_edge_row',
			COLUMN: 'cell_edge_column',
			CELL: 'cell',
			MEASURE: 'values',
			SUMMARY: 'summary'
		},

		DEFAULT_TEXT_STYLE: {
			FONT_SIZE: '10pt',
			FONT_FAMILY: 'IBM Plex Sans',
			PADDING_WIDTH: 18
		},

		EVENTTYPE: {
			CUSTOMDATA: 'customdata',
			DATAPOINT: 'datapoint',
			ITEMCLASS: 'itemclass',
			ITEM: 'item',
			SUMMARY: 'summary',
			EXPANDED: 'expanded'
		},

		EDGE_TYPE: {
			ROW: 'row',
			COL: 'col',
			COLUMN: 'column'
		},

		TEXT_STYLE_INDEX: {
			CELL: 'dataValueStyles',
			corner: 'valueHeadingStyles',
			row: 'rowHeadingStyles',
			column: 'columnHeadingStyles',
			SUMMARY: 'summaryStyles',
			SELECTED_AREA: 'selectedAreaStyles'
		},

		JUSTIFY_OPTIONS: {
			Right: 'flex-end',
			Left: 'flex-start',
			Center: 'center'
		},

		STYLE_CSS_MAP: {
			Color: 'color',
			FontSize: 'font-size',
			FontFace: 'font-family',
			FontBold: 'font-weight',
			FontItalic: 'font-style',
			FontUnderline: 'text-decoration',
			FontAlign: 'text-align',
			TextWrap: ['word-break','white-space']
		},

		STYLE_TO_VALUE: {
			'font-weight': 'bold',
			'font-style': 'italic',
			'text-decoration': 'underline',
			'word-break': 'break-all',
			'white-space': 'initial'
		},

		PROP_ID_SUPPRESSION: 'suppression',
		PROP_ID_EXPANDCOLLAPSE: 'expandCollapse',
		MEASURE_ROW_RESIZE_IDENTIFIER: 'Measures_Row',

		DEFAULT_ROW_HEIGHT: 32,
		DEFAULT_COLUMN_WIDTH: 120,
		MIN_ROW_HEIGHT: 24,
		MIN_COLUMN_WIDTH: 24,
		SHAPE_WIDTH: 24,
		// hiddenRowHeight is set as a small float number that is close to 0 to prevent the react removing the dom with 0 height
		HIDDEN_ROW_HEIGHT: 0.000001,
		// hiddenColumnWidth is set as a small float number that is close to 0 to prevent the react removing the dom with 0 width
		HIDDEN_COL_WIDTH: 0.000001,
		EXPAND_INDENTATION: 24,
		EXPAND_INDENTATION_HEIGHT: 32,
		PROP_ID_HIDDEN_ROWS_AND_COLS: 'hiddenRowsAndColumns',
		AXIS_X: 'x',
		AXIS_Y: 'y',
		TABINDEX: 0
	};

});
